import { denormaliseEmojiServiceResponse, emojiRequest } from './EmojiUtils';

/**
 * Emoji providers should return JSON in the format defined by EmojiServiceResponse.
 */
export default class EmojiLoader {
  constructor(config) {
    this.config = config;
  }

  /**
   * Returns a promise with an array of Emoji from all providers.
   */
  loadEmoji() {
    const emojisPromise = emojiRequest(this.config);
    return emojisPromise.then(emojiServiceResponse => denormaliseEmojiServiceResponse(emojiServiceResponse));
  }
}